import * as React from "react";
import {Bundle} from "data/BundleData";
import {UIState} from "data/UIState";
import {ResData, ResDataFactory} from "components/reservations/ResData";
// import {useEffect, useState} from "react";
import {IReservation} from "shared/IReservation";
import { DateTime, Duration } from "luxon";

import {IResOptions} from "shared/ResOptions";
import {Photo} from "components/Photo";
import {PhotoRendered} from "components/PhotoRendered";
import {DateTimeFormat, DateTimeHelpers} from "shared/DateTimeHelpers";

import './ReservationsBlock.pcss';
import {toJS} from "mobx";

interface Props {
  bundle:Bundle;
  //solutionId:string;
  resData:ResData;
  reservations:IReservation[];
  setReservations:(reservations:IReservation[])=>void;
  solo?:boolean;
}

/**
 * Embeds the reservation scheduler
 *
 * @param props
 * @constructor
 */
export const ReservationsBlock = (props:Props) => {

  // const [resData, setResData] = useState<ResData>();
  // const [reservations, setReservations] = useState<IReservation[]>([]);
  //
  // useEffect(()=>{
  //   if(props.bundle && props.bundle.enableReservations && props.bundle.resOptions) {
  //     ResDataFactory(props.bundle, UIState.user, props.solutionId)
  //       .then((resData: ResData) => {
  //         setResData(resData);
  //         setReservations(resData.reservations?resData.reservationsNewestFirst:[]);
  //       })
  //       .catch((reason) => {
  //         console.log(reason)
  //       });
  //   }
  // }, []);

  function onClose(_resData:ResData) {
    const reservations = _resData.reservations?_resData.reservationsNewestFirst:[];
    props.setReservations(toJS(reservations));
  }

  const resData = props.resData;
  const reservations = props.reservations;

  if(resData) {

    const reservationsToManage = reservations.length!==0;
    const nothingActiveReservationsOpen = resData.reservationsOpen && !reservationsToManage;
    const miniCal = new Photo( '/img/mini_cal.svg');
    const clockRewind = new Photo( '/img/clock_rewind.png');

    return (
      <div className={`reservations-block${props.solo ? " solo" : ""}`}>
        <div className={"rb-header"}>
          <h3>{props.bundle.resOptions.uiWordReservation}s</h3>
          {reservationsToManage && <button onClick={() => { UIState.openScheduler(resData, onClose); }}>Manage Reservations <span className={"material-icons"}>arrow_forward_ios</span></button> }
        </div>

        {nothingActiveReservationsOpen &&
          <div className={"rb-reserve-now"}>
            <div aria-hidden><PhotoRendered photo={miniCal} /></div>
            <div>
              <h4>{resData.what}</h4>
              <p>
                Reserve before&nbsp;{DateTimeHelpers.format(resData.furthestCloseDate, DateTimeFormat._END_TIME_AND_ZONE ,resData.resOptions.timezone)}
                &nbsp;on&nbsp;
                {DateTimeHelpers.format(resData.furthestCloseDate, DateTimeFormat.SHORT_MONTH_DAY, resData.resOptions.timezone)}
              </p>
            </div>
            <div className={"cardButton"}>
              <button onClick={() => { UIState.openScheduler(resData, onClose); }}><span className={"lab"}>Reserve Now</span><span aria-hidden className="material-icons">arrow_forward_ios</span></button>
            </div>
          </div>
        }

        {!reservationsToManage && !nothingActiveReservationsOpen &&
          <div className={"rb-reserve-now"}>
            <div aria-hidden><PhotoRendered photo={clockRewind} /></div>
            <div>
              <p>Reservations have closed</p>
            </div>
          </div>
        }

        <div className="rb-reservations">
          {reservations.map((res: IReservation) => <ReservationBlockItem
            key={res._id}
            reservation={res}
            resOptions={props.bundle.resOptions}
            />
          )}
        </div>
      </div>
    );
  } else {
    return null;
  }

}

interface ReservationBlockItemProps {
  reservation: IReservation;
  resOptions: IResOptions;
}

const ReservationBlockItem = (props: ReservationBlockItemProps) => {

  const timeStart = DateTimeHelpers.parseDateTime(props.reservation.time);

  if(null===timeStart) {
    console.log("ReservationBlockItem props.reservation.time is not set.");
    return null;
  }

  const timeEnd = timeStart.plus(Duration.fromObject({minutes: props.reservation.length}));
  if(DateTime.now()>timeEnd) {

    return (
      <div className={"reservation-block-item-complete"}>
        <div className={"rbic-icon"}><span className={'material-icons'}>event_available</span></div>
        <div className={"rbic-date"}>
          {DateTimeHelpers.format(timeStart, DateTimeFormat._START_DATE, props.resOptions.timezone)},&nbsp;
          {DateTimeHelpers.format(timeStart, DateTimeFormat.HOUR_MIN, props.resOptions.timezone)}-{DateTimeHelpers.format(timeEnd, DateTimeFormat._END_TIME_AND_ZONE, props.resOptions.timezone)}
        </div>
        {props.reservation.pointsHandled &&
        <>
        {props.reservation.pointsForAttending &&
        <>
          {props.reservation.didAttend ?
            <div className={"rbic-points"}>+{props.reservation.pointsForAttending} point{props.reservation.pointsForAttending>1?"s":""}</div>
            :
            <div className={"rbic-did-not-attend"}>You did not attend</div>
          }
        </>
        }
        </>
        }
      </div>
    )

  } else {

    const isZoom = !!props.reservation.joinURL;
    const upcoming = timeStart > DateTime.now();
    const happeningNow = !upcoming && timeEnd > DateTime.now();
    //const alreadyComplete = !happeningNow && !upcoming;

    const desc = isZoom ? "Zoom Meeting" : upcoming ? `Starts ${timeStart.toRelative()}` : happeningNow ? "In Progress" : "Complete";

    return (
      <div className={"reservation-block-item"}>
        <div className={"rbi-icon"}><span className={'material-icons'}>event_available</span></div>
        <div className={"rbi-details"}>
          <div className={"rbi-details-line1"}>
            <strong>{DateTimeHelpers.format(timeStart, DateTimeFormat._START_DATE, props.resOptions.timezone)},</strong>&nbsp;
            {DateTimeHelpers.format(timeStart, DateTimeFormat.HOUR_MIN, props.resOptions.timezone)}-{DateTimeHelpers.format(timeEnd, DateTimeFormat._END_TIME_AND_ZONE, props.resOptions.timezone)}
          </div>
          <div className={"rbi-details-line2"}>
            {props.reservation.length} minute {props.resOptions.uiWordEventType}
            {desc && <>&nbsp;&bull;&nbsp;{desc}</>}
          </div>

          {isZoom &&
            <>
              {upcoming && <div>
                <div className={'rbi-copy-link'}>
                  <div>{props.reservation.joinURL}</div>
                  <button onClick={() => {
                    navigator.clipboard.writeText(props.reservation.joinURL);
                    //this.copied = true;
                  }}>COPY LINK
                  </button>
                </div>
                {/*<div className={'copy-status'}>{this.copied && <span>copied to clipboard</span>}</div>*/}
              </div>
              }
              {happeningNow && <div className={'rbi-join-now'}>
                <a href={props.reservation.joinURL} target={"_blank"}>Join Now</a>
              </div>
              }
            </>
          }

        </div>
      </div>
    );
  }
}
